import { PAGE_TYPES } from '../shared/utils/analytics/constants'

export const microPrefix = 'nol-portal-authentication'

export function getPageType(slug) {
	if (slug === '/login/') return PAGE_TYPES.GENERIC
	if (slug === '/login/recuperar/') return PAGE_TYPES.GENERIC

	return PAGE_TYPES.GENERIC
}
